export enum FileUploadStatus {
  pending,
  uploading,
  success,
  error,
}
